import React from 'react';

/**
 * Score ring for Quality column.
 * Matches comp .score / .score .ring pattern.
 * Shows numeric ring + "signal q." when score present; "—" ring + "unscored" when absent.
 */
interface SourceQualityRingProps {
  overallScore: string | null | undefined;
}

function ringClasses(score: number): { ring: string; label: string } {
  if (score >= 70) return { ring: 'bg-success-muted text-success', label: 'signal q.' };
  if (score >= 40) return { ring: 'bg-warning-muted text-warning', label: 'signal q.' };
  return { ring: 'bg-surface-alt text-muted', label: 'signal q.' };
}

export const SourceQualityRing: React.FC<SourceQualityRingProps> = ({ overallScore }) => {
  const raw = parseFloat(overallScore ?? '');
  // Treat as 0–100 scale: if the stored value is between 0–1 multiply by 100
  const score = !isNaN(raw) && raw > 0 ? (raw <= 1 ? raw * 100 : raw) : NaN;
  const hasScore = !isNaN(score) && score > 0;

  if (!hasScore) {
    return (
      <span className="inline-flex items-center gap-[7px] font-mono text-[12px] text-faint">
        <span className="inline-grid place-items-center w-[30px] h-[30px] rounded-full bg-surface-alt text-faint font-semibold text-[10px]">
          —
        </span>
        unscored
      </span>
    );
  }

  const { ring } = ringClasses(score);
  return (
    <span className="inline-flex items-center gap-[7px] font-mono text-[12px]">
      <span
        className={`inline-grid place-items-center w-[30px] h-[30px] rounded-full font-semibold text-[10px] ${ring}`}
      >
        {Math.round(score)}
      </span>
      <span className="text-muted">signal q.</span>
    </span>
  );
};
